<template>
    <div class="space-y-2 px-2 py-1 sm:rounded-lg">
        <slot />
    </div>
</template>
